import * as icons from 'assets/icons'
import SVG from 'components/priority/SVG/SVG'
import type { IconProps } from 'types/svg'

export const Icon = ({ icon, fill, ...props }: IconProps) => (
  <SVG src={icons[icon]} fill={fill} {...props} />
)

export default Icon
